import n from 'react';
import p from 'classnames';

var r="5fc950a9e6b68f07f449ff7f6c26c3ce943b37e77b4e722d3f7b8c03069fe3ef",a=`._container_1ae9q_1 {
	position: relative;
	padding-left: 10px;
	font-weight: 400;
	font-size: 14px;
	color: rgb(var(--csb-ck-color-text-subtle));
	margin: 12px 0;
	--field-tips-color: rgb(var(--csb-ck-color-text));
}

._container_1ae9q_1::before {
	content: "";
	position: absolute;
	left: 0;
	top: 0;
	bottom: 0;
	width: 3px;
	border-radius: 100vh;
	transition: background-color 0.2s;
	background-color: var(--field-tips-color);
}
`;(function(){if(!(typeof document>"u")&&!document.getElementById(r)){var e=document.createElement("style");e.id=r,e.textContent=a,document.head.appendChild(e);}})();var i={container:"_container_1ae9q_1"};function u({className:e,style:t,color:o,...s}){let c=n.useMemo(()=>({"--field-tips-color":o,...t}),[t,o]);return n.createElement("div",{className:p(e,i.container),style:c,...s})}

export { u as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-BYJTSHAJ.mjs.map